import styled, { css } from 'styled-components/macro';
import { FlexColumn } from '../../../../../shared-styles/flex';

export const Container = styled.div`
  ${(props) => (
    !props.stacked ? css`
      display: grid;
      grid-template-columns:  ${props.columnTemplate};
      grid-gap: ${props.theme.spacing(5)};
    ` : css`
      ${FlexColumn}
      gap: ${props.theme.spacing(5)}
    `)};
`;

export const Label = styled.span`
  font-size: ${(props) => props.theme.typography.sizes.small};
  font-weight: ${(props) => props.theme.typography.weight.semiBold};
  color: ${(props) => (props.darkBlueText ? props.theme.palette.darkBlue[100] : '')};
`;

export const Value = styled.span`
  font-size: ${(props) => props.theme.typography.sizes.small};
`;
